const DEFAULT_OBSERVER_ID = 'default-observer';
const MODAL_OBSERVER_ID = 'modal-toast-render';

export const TOAST_TYPES = {
  WARNING: 'warning',
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
} as const;

export const TIME_BEFORE_UNMOUNT = 200;
export const TOAST_WIDTH = 496;
export const GAP = 14;

export const OBSERVER_ID = {
  DEFAULT: DEFAULT_OBSERVER_ID,
  MODAL: MODAL_OBSERVER_ID,
} as const;
